var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Content",
    { class: _vm.classNames, attrs: { "app-name": "calendar" } },
    [
      !_vm.isEmbedded
        ? _c(
            "AppNavigation",
            {
              scopedSlots: _vm._u(
                [
                  {
                    key: "list",
                    fn: function() {
                      return [
                        _c("AppNavigationSpacer"),
                        _vm._v(" "),
                        _c("CalendarList", {
                          attrs: {
                            "is-public": !_vm.isAuthenticatedUser,
                            "loading-calendars": _vm.loadingCalendars
                          }
                        }),
                        _vm._v(" "),
                        !_vm.loadingCalendars && _vm.isAuthenticatedUser
                          ? _c("CalendarListNew", {
                              attrs: { disabled: _vm.loadingCalendars }
                            })
                          : _vm._e()
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "footer",
                    fn: function() {
                      return [
                        _vm.isAuthenticatedUser
                          ? _c("Settings", {
                              attrs: {
                                "loading-calendars": _vm.loadingCalendars
                              }
                            })
                          : _vm._e()
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                2242494356
              )
            },
            [
              _c("AppNavigationHeader", {
                attrs: { "is-public": !_vm.isAuthenticatedUser }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isEmbedded ? _c("EmbedTopNavigation") : _vm._e(),
      _vm._v(" "),
      _c(
        "AppContent",
        [
          _c("CalendarGrid", {
            attrs: { "is-authenticated-user": _vm.isAuthenticatedUser }
          }),
          _vm._v(" "),
          _vm.showEmptyCalendarScreen ? _c("EmptyCalendar") : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }